import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Loader from '../../Loader';
import { useIntl } from 'react-intl';
import getDynamicHomeValue from '../../../helpers/GetDynamicItemName/dynamicHomeValue';
import s from './BannerCaption.css';

function BannerCaption({ data }) {
  const { loading, getBanner } = data;

  const { locale } = useIntl();

  if (loading || !getBanner) {
    return <Loader type="text" />;
  }

  const { title, content } = getDynamicHomeValue(getBanner, locale);

  return (
    <div className={cx(s.bannerCaptionContainer)}>
      <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
        {title}
      </h1>
      <p className={s.bannerCaptionPara}>{content}</p>
    </div>
  );
}

BannerCaption.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getBanner: PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      content: PropTypes.string,
      dynamicBanner: PropTypes.array,
    }),
  }),
};

export default withStyles(s)(BannerCaption);
